
import './App.css';
import Navbar from './pages/Navbar/Navbar.tsx';
import Dashboard from './pages/Dashboard/Dashboard.tsx';

function App() {
  return (
    <div className=''>
      <Navbar />
      <Dashboard />
    </div>
  );
}

export default App;
